// ============================================================================
// PixelPapad — CMS-ready content. Edit these objects to update the site.
// All testimonials / portfolio / team bios / counters are LABELLED PLACEHOLDERS.
// ============================================================================

export const CONTACT = {
  website: "www.pixelpapad.com",
  phone: "9922284030", // editable
  whatsapp: "919922284693", // editable — used for wa.me links
  email: "info@pixelpapad.com", // editable placeholder
  address: "Chhatrapati Sambhajinagar, Maharashtra, India", // editable placeholder
  hours: "Mon–Sat, 10:00 AM – 7:00 PM IST", // editable placeholder
  socials: {
    instagram: "#", // editable placeholder
    facebook: "#",
    linkedin: "#",
    youtube: "#",
  },
};

export const waLink = (text = "Hi PixelPapad, I'd like to discuss a project.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "work", label: "Work" },
  { id: "solutions", label: "Solutions" },
  { id: "pricing", label: "Pricing" },
  { id: "process", label: "Process" },
  { id: "team", label: "Team" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const HERO_ROTATING = ["Creative", "Strategy", "Content", "Performance", "Growth"];

export const HERO_CHIPS = [
  "Social Media", "Branding", "Video", "Performance Ads", "Web Development", "Celebrity Campaigns",
];

export const PILLARS = [
  { title: "Creativity", desc: "Ideas that break the scroll and stick in memory.", color: "#F59E0B" },
  { title: "Strategy", desc: "Every creative decision anchored to a business goal.", color: "#8B5CF6" },
  { title: "Execution", desc: "Design, shoot, edit, develop — shipped on time.", color: "#EC4899" },
  { title: "Consistency", desc: "A steady drumbeat of content that compounds.", color: "#06B6D4" },
];

// Counters — PLACEHOLDER values. Replace with verified company data.
export const COUNTERS = [
  { label: "Creative Projects", value: 120, suffix: "+", placeholder: true },
  { label: "Industries Served", value: 14, suffix: "+", placeholder: true },
  { label: "Content Assets Produced", value: 5000, suffix: "+", placeholder: true },
  { label: "Campaigns Managed", value: 80, suffix: "+", placeholder: true },
];

export const SERVICES = [
  {
    id: "social-media", title: "Social Media Marketing", short: "Grow & manage your social presence.",
    cta: "Grow My Social Presence", color: "#F59E0B",
    items: ["Social media strategy", "Instagram management", "Facebook management", "LinkedIn management",
      "Content calendars", "Captions & hashtag research", "Community engagement", "Social media reporting",
      "Campaign management", "Profile optimisation"],
  },
  {
    id: "graphic-design", title: "Graphic Design", short: "Creatives that stop the scroll.",
    cta: "Design My Campaign", color: "#EC4899",
    items: ["Social media creatives", "Advertising creatives", "Campaign banners", "Brochures", "Posters",
      "Packaging graphics", "Presentation design", "Marketing collateral", "Festival creatives", "Corporate designs"],
  },
  {
    id: "branding", title: "Branding & Visual Identity", short: "Distinctive brands, built to last.",
    cta: "Build My Brand", color: "#8B5CF6",
    items: ["Brand strategy", "Logo design", "Colour system", "Typography system", "Brand guidelines",
      "Brand voice", "Rebranding", "Corporate identity", "Launch identity", "Creative direction"],
  },
  {
    id: "content", title: "Content Creation", short: "Storytelling across every format.",
    cta: "Create My Content", color: "#06B6D4",
    items: ["Content strategy", "Copywriting", "Short-form content", "Product content", "Corporate content",
      "Campaign concepts", "Photography coordination", "Creative asset development", "Content calendars", "Storytelling"],
  },
  {
    id: "video", title: "Video Production & Editing", short: "Reels, films and motion that move.",
    cta: "Produce My Video", color: "#3B82F6",
    items: ["Reels", "Social media videos", "Product videos", "Corporate videos", "Motion graphics",
      "Video editing", "Colour correction", "Sound design", "YouTube videos", "Promotional films"],
  },
  {
    id: "performance", title: "Performance Marketing", short: "Ads engineered for outcomes.",
    cta: "Launch My Campaign", color: "#F59E0B",
    note: "Advertising budget is charged separately.",
    items: ["Meta advertising", "Instagram advertising", "Facebook advertising", "Google advertising",
      "YouTube advertising", "Lead-generation campaigns", "Sales campaigns", "Retargeting",
      "Conversion tracking", "Campaign optimisation", "Monthly reporting"],
  },
  {
    id: "seo", title: "Search Engine Optimisation", short: "Get found where it matters.",
    cta: "Improve My Ranking", color: "#8B5CF6",
    items: ["SEO audit", "Keyword research", "On-page SEO", "Technical SEO", "Local SEO",
      "Content optimisation", "Competitor analysis", "Link-building strategy", "Google Business Profile support", "Monthly reports"],
  },
  {
    id: "influencer", title: "Influencer Marketing", short: "Creators matched to your brand.",
    cta: "Find My Creators", color: "#EC4899",
    items: ["Influencer discovery", "Creator shortlisting", "Campaign strategy", "Outreach & coordination",
      "Brief development", "Content approval", "Campaign monitoring", "Reporting", "Regional creators",
      "Nano, micro & macro influencers"],
  },
  {
    id: "celebrity", title: "Celebrity Collaborations", short: "Star power, coordinated end to end.",
    cta: "Plan a Celebrity Campaign", color: "#06B6D4", price: "Custom Quote",
    items: ["Bollywood personalities", "Regional celebrities", "Brand ambassadors", "Campaign appearances",
      "Social promotions", "Event appearances", "Production coordination", "Celebrity campaign planning"],
  },
  {
    id: "tv-ott", title: "TV Commercials & OTT Advertising", short: "Broadcast-grade production.",
    cta: "Create My Commercial", color: "#3B82F6", price: "Custom Production Quote",
    items: ["TV commercial concepts", "Script development", "Pre-production", "Production coordination",
      "Post-production", "OTT campaign creatives", "Hotstar advertising support", "Media planning coordination",
      "Campaign adaptations", "Digital commercial production"],
  },
  {
    id: "web", title: "Web Design & Development", short: "Websites that convert.",
    cta: "Build My Website", color: "#F59E0B",
    items: ["Business websites", "Landing pages", "E-commerce websites", "Custom websites", "UI/UX design",
      "Responsive development", "Website redesign", "CMS development", "Conversion optimisation",
      "Website maintenance", "3D interactive websites", "AI-powered website features"],
  },
  {
    id: "campaign", title: "Creative Campaign Support", short: "Your daily creative engine.",
    cta: "Plan My Campaign", color: "#8B5CF6",
    items: ["Campaign concepts", "Creative direction", "Launch campaigns", "Brand communication",
      "Advertising assets", "Campaign banners", "Multi-platform adaptation", "Daily creative support",
      "Review & quality control", "Creative coordination"],
  },
];

export const WHY = [
  "Eye-Catching Creatives", "Strong Brand Communication", "Fast Execution", "Visual Storytelling",
  "Daily Content Support", "Customer Engagement", "Creative with Performance Thinking",
  "Consistent Visual Identity", "Full-Service Execution", "One Coordinated Creative Team",
];

export const WORK_FILTERS = ["All", "Branding", "Social Media", "Video", "Performance Ads", "Web", "Commercials", "Influencer Campaigns"];

// Portfolio — DEMO placeholders. Replace with verified client work.
export const PORTFOLIO = [
  { id: "p1", title: "Neon Kitchen Rebrand", category: "Branding", industry: "Food & Restaurants", service: "Branding & Identity", goal: "Refresh a legacy brand for a younger audience.", outcome: "Demo project — replace with verified client work.", image: "https://images.unsplash.com/photo-1696041756040-c910a971f222?w=1200&q=80", span: "lg:col-span-8" },
  { id: "p2", title: "Launch Reel Series", category: "Video", industry: "Fashion", service: "Video Production", goal: "Build hype for a seasonal drop.", outcome: "Demo project — replace with verified client work.", image: "https://images.unsplash.com/photo-1557838923-2985c318be48?w=900&q=80", span: "lg:col-span-4" },
  { id: "p3", title: "Always-On Social Engine", category: "Social Media", industry: "Beauty", service: "Social Media", goal: "Consistent daily content.", outcome: "Demo project — replace with verified client work.", image: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?w=900&q=80", span: "lg:col-span-4" },
  { id: "p4", title: "Performance Sprint", category: "Performance Ads", industry: "E-commerce", service: "Performance Marketing", goal: "Scale profitable acquisition.", outcome: "Demo project — replace with verified client work.", image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80", span: "lg:col-span-8" },
  { id: "p5", title: "3D Product Microsite", category: "Web", industry: "Technology", service: "Web Development", goal: "An immersive product launch page.", outcome: "Demo project — replace with verified client work.", image: "https://images.unsplash.com/photo-1618004912476-29818d81ae2e?w=900&q=80", span: "lg:col-span-6" },
  { id: "p6", title: "Regional Creator Wave", category: "Influencer Campaigns", industry: "Local Businesses", service: "Influencer Marketing", goal: "Hyperlocal reach via creators.", outcome: "Demo project — replace with verified client work.", image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=900&q=80", span: "lg:col-span-6" },
];

export const PROCESS = [
  { step: "01", title: "Discover", desc: "We understand your brand, audience, goals and challenges." },
  { step: "02", title: "Strategise", desc: "We prepare the creative, content and channel roadmap." },
  { step: "03", title: "Create", desc: "Our team designs, writes, shoots, edits and develops." },
  { step: "04", title: "Launch", desc: "Campaigns and creative assets go live across selected platforms." },
  { step: "05", title: "Optimise", desc: "We review performance and improve execution." },
  { step: "06", title: "Scale", desc: "Successful systems are expanded for consistent growth." },
];

export const PLANS = [
  {
    id: "starter", name: "Creative Starter", price: "\u20b924,999", period: "/month", popular: false,
    best: "Local businesses, professionals and early-stage brands.", cta: "Choose Starter",
    features: ["1 primary social media platform", "12 static posts", "4 basic reels", "Monthly content calendar",
      "Caption writing", "Basic hashtag research", "Profile optimisation", "Festival creatives",
      "Monthly performance report", "1 monthly strategy call", "Up to 2 revision rounds per asset"],
  },
  {
    id: "growth", name: "Brand Growth", price: "\u20b949,999", period: "/month", popular: true,
    best: "Growing businesses requiring consistent content and campaigns.", cta: "Grow My Brand",
    note: "Advertising spend is not included.",
    features: ["Up to 3 social platforms", "16 static or carousel posts", "8 edited reels", "Content strategy",
      "Monthly content calendar", "Caption & hashtag research", "Community-management guidance",
      "4 advertising creative sets", "Basic Meta Ads management", "Monthly campaign reporting",
      "2 strategy calls", "Up to 3 revision rounds per asset"],
  },
  {
    id: "pro", name: "Performance Pro", price: "\u20b989,999", period: "/month", popular: false,
    best: "Brands that want creative production and performance marketing together.", cta: "Scale My Campaigns",
    note: "Advertising spend, influencer fees and production expenses are charged separately.",
    features: ["Up to 4 social platforms", "20 static or carousel posts", "12 reels or edited videos",
      "Content & campaign strategy", "Meta Ads management", "Google Ads management",
      "Conversion tracking coordination", "Retargeting campaign setup", "Landing-page consultation",
      "Monthly creative testing", "Campaign dashboards", "Competitor insights", "Dedicated account manager",
      "Weekly review call"],
  },
  {
    id: "dominance", name: "Full-Service Dominance", price: "Starting \u20b91,49,999", period: "/month", popular: false,
    best: "Established brands requiring a complete outsourced creative and marketing team.", cta: "Request Custom Proposal",
    features: ["Multi-platform social media management", "Brand strategy", "Creative direction",
      "High-volume design support", "Advanced video editing", "Performance advertising", "SEO support",
      "Landing-page development", "Influencer campaign coordination", "Campaign planning",
      "Monthly production day coordination", "Analytics & reporting", "Priority turnaround",
      "Dedicated strategy & execution team"],
  },
];

export const PRICING_DISCLAIMER =
  "Prices are starting estimates and may vary depending on deliverables, platforms, content volume, production requirements and campaign complexity. Advertising spend, influencer or celebrity fees, travel, studio, actors, locations, media buying, software subscriptions, taxes and third-party expenses are not included unless specifically mentioned.";

export const ADDONS = [
  { name: "Additional static creative", price: "\u20b9800 onwards" },
  { name: "Carousel design", price: "\u20b91,500 onwards" },
  { name: "Additional edited reel", price: "\u20b92,500 onwards" },
  { name: "Motion-graphics reel", price: "\u20b95,000 onwards" },
  { name: "On-location content shoot", price: "\u20b915,000 onwards" },
  { name: "Brand identity package", price: "\u20b935,000 onwards" },
  { name: "Landing page", price: "\u20b925,000 onwards" },
  { name: "Business website", price: "\u20b960,000 onwards" },
  { name: "E-commerce website", price: "\u20b91,25,000 onwards" },
  { name: "Interactive 3D website", price: "\u20b92,50,000 onwards" },
  { name: "SEO management", price: "\u20b925,000/month onwards" },
  { name: "Meta Ads management", price: "\u20b915,000/month onwards" },
  { name: "Google Ads management", price: "\u20b920,000/month onwards" },
  { name: "Influencer campaign management", price: "\u20b925,000 onwards" },
  { name: "TV commercial or OTT production", price: "Custom quote" },
  { name: "Celebrity collaboration", price: "Custom quote" },
];

export const INDUSTRIES = [
  "E-commerce", "Quick Commerce", "Logistics", "Education", "Healthcare", "Real Estate", "Hospitality",
  "Fashion", "Beauty", "Food & Restaurants", "Technology", "Professional Services", "Local Businesses", "Startups",
];

export const TEAM = [
  { name: "Imran Isa Patel", role: "Founder", lead: true, bio: "Editable placeholder — official biography to be provided." },
  { name: "Samrin Khan", role: "Co-Founder", lead: true, bio: "Editable placeholder — official biography to be provided." },
  { name: "Team Member", role: "Social Media Executive", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Graphic Designer", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Video Editor", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Performance Marketer", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Content Strategist", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Web Developer", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Creative Coordinator", bio: "Editable placeholder bio." },
  { name: "Team Member", role: "Review & Quality Control", bio: "Editable placeholder bio." },
];

export const COLLABS = [
  { title: "Bollywood Stars", desc: "National-scale faces for high-impact brand moments." },
  { title: "Influencers", desc: "Nano to macro creators matched to your audience." },
  { title: "Brand Ambassadors", desc: "Long-term faces that embody your brand." },
];

// Testimonials — PLACEHOLDERS. Do not publish as real until verified.
export const TESTIMONIALS = [
  { quote: "Placeholder testimonial — replace with a verified client quote before publishing.", name: "Client Name (placeholder)", role: "Role, Company (placeholder)" },
  { quote: "Placeholder testimonial — replace with a verified client quote before publishing.", name: "Client Name (placeholder)", role: "Role, Company (placeholder)" },
  { quote: "Placeholder testimonial — replace with a verified client quote before publishing.", name: "Client Name (placeholder)", role: "Role, Company (placeholder)" },
];

export const FAQS = [
  { q: "What services does PixelPapad provide?", a: "We offer social media marketing, graphic design, branding, content creation, video production, performance marketing, SEO, influencer marketing, celebrity collaborations, TV/OTT advertising, web design & development, and creative campaign support." },
  { q: "Can I select individual services?", a: "Yes. You can pick a monthly plan or request a custom scope built around only the services you need." },
  { q: "Is advertising spend included in the plans?", a: "No. Advertising spend (media budget) is billed separately and paid directly to the ad platforms." },
  { q: "How quickly can a project start?", a: "Most projects begin within a few working days of a discovery call and onboarding." },
  { q: "How many revisions are included?", a: "Revision rounds vary by plan (typically 2–3 per asset). Additional rounds can be added." },
  { q: "Do you work with clients outside Chhatrapati Sambhajinagar?", a: "Yes. We work with clients across India and remotely." },
  { q: "Can you manage both creative work and paid advertising?", a: "Yes. Our Performance Pro and Full-Service plans combine creative production with paid media management." },
  { q: "Do you arrange influencers and celebrities?", a: "Yes. We coordinate creator discovery, celebrity collaborations, briefs, approvals and campaign execution." },
  { q: "Do you produce TV commercials and OTT advertisements?", a: "Yes. We handle concepts, scripting, production coordination and post-production on a custom-quote basis." },
  { q: "Can you build 3D and AI-powered websites?", a: "Yes. We build interactive 3D websites and AI-powered web features as part of web development." },
  { q: "Are photography and video shoots included?", a: "Shoots are quoted separately based on location, crew and production requirements." },
  { q: "How is custom pricing calculated?", a: "We map your deliverables, platforms, content volume and production needs, then confirm pricing after a discovery call." },
];

export const PLANNER_STEPS = {
  businessTypes: ["E-commerce", "Restaurant / Food", "Real Estate", "Healthcare", "Education", "Fashion / Beauty", "Technology / SaaS", "Professional Services", "Local Business", "Startup", "Other"],
  services: SERVICES.map((s) => s.title),
  budgets: ["Below \u20b925,000", "\u20b925,000–\u20b950,000", "\u20b950,000–\u20b91,00,000", "\u20b91,00,000–\u20b92,00,000", "Above \u20b92,00,000", "Need consultation"],
  objectives: ["Brand awareness", "Lead generation", "Sales / conversions", "Product launch", "Community growth", "Full rebrand"],
  platforms: ["Instagram", "Facebook", "LinkedIn", "YouTube", "Google", "Website"],
  timelines: ["Immediately", "Within 2 weeks", "Within a month", "Just exploring"],
};

export const CALC_OPTIONS = {
  platforms: [{ label: "1 platform", value: 6000 }, { label: "2 platforms", value: 11000 }, { label: "3 platforms", value: 16000 }, { label: "4+ platforms", value: 22000 }],
  posts: [{ label: "8 posts", value: 6000 }, { label: "12 posts", value: 9000 }, { label: "16 posts", value: 12000 }, { label: "20+ posts", value: 16000 }],
  reels: [{ label: "0 reels", value: 0 }, { label: "4 reels", value: 8000 }, { label: "8 reels", value: 15000 }, { label: "12+ reels", value: 22000 }],
  ads: [{ label: "No ad management", value: 0 }, { label: "Meta Ads", value: 15000 }, { label: "Meta + Google", value: 30000 }],
  seo: [{ label: "No SEO", value: 0 }, { label: "SEO management", value: 25000 }],
  shoot: [{ label: "No shoot", value: 0 }, { label: "1 shoot day", value: 15000 }],
  influencer: [{ label: "No influencers", value: 0 }, { label: "Influencer campaign", value: 25000 }],
  website: [{ label: "No website", value: 0 }, { label: "Landing page", value: 25000 }, { label: "Business website", value: 60000 }],
};
